"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carTitleStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        title: {
            fontFamily: typography.fontFamily2,
        },
        titleWrapper: {
            width: '100%',
        },
        carMake: {
            fontFamily: typography.fontFamily2,
            marginRight: '5px',
        },
    });
}, { name: 'Summary_CarTitle' });
exports.default = carTitleStyles;
